import { Alert, Button, Collapse } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useLegalConsentSummary } from '../useLegalConsentSummary';

export default function LegalReacceptanceBanner() {
  const { data: summary } = useLegalConsentSummary();

  if (!summary?.needsReacceptance) {
    return null;
  }

  return (
    <Collapse in>
      <Alert
        severity="warning"
        sx={{ borderRadius: 0 }}
        action={
          <Button component={RouterLink} to="/mes-consentements" color="inherit" size="small">
            Mettre a jour
          </Button>
        }
      >
        Une nouvelle version des documents legaux est disponible. Une reacceptation est recommandee avant vos prochains parcours engages.
      </Alert>
    </Collapse>
  );
}